<script setup lang="ts">
import exportIcon from '~/assets/images/user/vip/icon-export.png'
import collectIcon from '~/assets/images/user/vip/icon-collect.png'
import filterIcon from '~/assets/images/user/vip/icon-filter.png'
import rankingIcon from '~/assets/images/user/vip/icon-rank.png'
import bloggerIcon from '~/assets/images/user/vip/icon-blogger.png'
import listIcon from '~/assets/images/user/vip/icon-list.png'
import createSearch from '~/assets/images/user/vip/icon-search.png'
import detailIcon from '~/assets/images/user/vip/icon-detail.png'

defineProps<{
  canClose?: boolean
}>()
const emits = defineEmits(['close'])
const { expriedType } = useExpired()
const { userRole } = useLogin()
const localePath = useLocalePath()
const { t } = useI18n()
const getUpgradeResource = computed(() => {
  if (expriedType.value === 4) {
    return { resource: 1, resourceName: '企业版', limit: 2000 }
  }
  switch (userRole.value?.resource) {
    case 3:
      return { resource: 2, resourceName: '专业版', limit: 10 }
    case 2:
      return { resource: 1, resourceName: '企业版', limit: 2000 }
    default:
      return { resource: 1, resourceName: '企业版', limit: 2000 }
  }
})
function toPay() {
  navigateTo(localePath(`/vip?type=${getUpgradeResource.value?.resource}`))
  emits('close')
}
function getBasePrivilegeItems(isResource2: boolean) {
  return [
    {
      icon: collectIcon,
      name: t('我的收藏'),
      desc: isResource2 ? t('vip.upTo1', [600]) : t('vip.upTo1', [2000]),
    },
    {
      icon: filterIcon,
      name: t('高级筛选'),
      desc: t('vip.不限'),
    },
    {
      icon: exportIcon,
      name: t('数据导出'),
      desc: isResource2 ? `100${t('次/月')}` : `500${t('次/月')}`,
    },
    {
      icon: rankingIcon,
      name: t('榜单数据'),
      desc: isResource2 ? t('vip.top', [500]) : t('vip.top', [1000]),
    },
  ]
}
function getBasePrivilegeItemsCoper() {
  return [
    {
      icon: exportIcon,
      name: t('数据导出'),
      desc: `500${t('次/月')}`,
    },
    {
      icon: bloggerIcon,
      name: t('联系方式导出'),
      desc: `150${t('次/月')}`,
    },
    {
      icon: listIcon,
      name: t('列表数据'),
      desc: t('vip.不限'),
    },
    {
      icon: collectIcon,
      name: t('我的收藏'),
      desc: t('vip.upTo1', [2000]),
    },
  ]
}
function getPrivilegeItems(isResource2: boolean) {
  if (isResource2) {
    return getBasePrivilegeItems(isResource2)
  }
  else {
    return getBasePrivilegeItemsCoper()
  }
}
const privilege = computed(() => {
  const isResource2 = getUpgradeResource.value?.resource === 2
  if (expriedType.value === 4)
    return getBasePrivilegeItemsCoper()
  let items = getPrivilegeItems(isResource2)
  if (isResource2) {
    if (expriedType.value === 3) {
      items = getBasePrivilegeItems(isResource2).sort((a) => {
        if (a.name === t('数据导出')) {
          return -1
        }
        return 1
      })
    }

    else if (expriedType.value === 5) {
      items = [
        {
          icon: detailIcon,
          name: t('查看详情'),
          desc: '90天数据',
        },
        items[2],
        ...getBasePrivilegeItems(isResource2).slice(0, 2),
      ]
    }
    else if (expriedType.value === 6) {
      items = [
        {
          icon: createSearch,
          name: t('搜索次数'),
          desc: '不限',
        },
        {
          icon: detailIcon,
          name: t('查看详情'),
          desc: '90天数据',
        },
        ...getBasePrivilegeItems(isResource2).slice(0, 2),
      ]
    }
  }
  else {
    if ([1, 2].includes(expriedType.value)) {
      // 将“我的收藏”放在最前面
      items = [items[3], items[2], ...items.slice(0, 2)]
    }
  }

  return items
})

const title = computed(() => {
  const isResource3 = userRole.value?.resource === 3
  const tip = isResource3 ? '开通' : '升级'
  const resourceName = t(getUpgradeResource.value?.resourceName || '')

  const defaultTip = t('vip.normalModal', [resourceName, tip])
  const messages: Record<number, string> = {
    1: defaultTip,
    2: t('vip.favouriteModal', [resourceName, tip]),
    // 3: isResource2 ? `${t('vip.exportModal', [resourceName, tip])}` : `您本月的数据导出次数已用完,${tip}${resourceName}享更多权益`,
    3: t('vip.exportModal', [resourceName, tip]),
    4: t('vip.exportCreatorModal', [t('企业版'), tip]),
    5: t('您今日的详情查看次数已用完，开通专业版享更多权益'),
    6: t('您今日的搜索次数已用完，开通专业版享更多权益'),
  }

  return messages[expriedType.value] || defaultTip
})
</script>

<template>
  <div class="g-expired-dialog__content relative relative h-fit flex flex-col items-center justify-center gap-24 px-50 py-24">
    <div
      v-if="canClose"
      class="absolute right-16 top-16 h-28 w-28 flex cursor-pointer items-center justify-center text-20 hover:op-80"
      @click="emits('close')"
    >
      <i class="icon-shanchu" />
    </div>
    <div class="text-16 text-[--color-text-1] font-500">
      {{ userRole?.resource === 3 ? $t('开通会员') : $t('升级提醒') }}
    </div>
    <div lass="text-14 text-[--color-text-1] ">
      {{ title }}
    </div>
    <div>
      <UserVipAsideContent
        :privilege="privilege" class="overflow-hidden !w-392"
        :resource="getUpgradeResource?.resource"
      />
    </div>
    <div mx-auto w-376>
      <UserVipBtn
        class="!h-54 !text-24" :payType="1" :data="getUpgradeResource"
        :label="userRole?.resource === 3 ? $t(`开通${getUpgradeResource?.resourceName}`) : $t(`升级${getUpgradeResource?.resourceName}`)"
        @click="toPay"
      />
    </div>
    <!-- <img class="w-172" src="~/assets/images/identity/expired.png" alt=""> -->
    <!-- <div class="pt-24 text-20 text-[--color-text-1] font-500">
        {{ $t('您的会员已过期') }}
      </div>
      <div class="pt-12 text-16 text-[--color-text-2]">
        {{ $t('开通会员可查看更多数据') }}
      </div>
      <a-button class="mt-40 h-44 w-252 rd-22 text-16 font-500" type="primary" @click="toPay">
        {{ $t('立即开通') }}
      </a-button> -->
  </div>
</template>

<style lang="less">
.g-expired-dialog__content {
  border-radius: 12px;
  background: linear-gradient(185deg, #FEF7F7 -15.28%, #F4F3FF 49.52%, #F5F3FF 52.41%, #FFF 93.6%);
}
</style>
